module.exports = __webpack_public_path__ + "static/media/gokrisp-use.0f3f1197.jpg";